import { Component, OnInit } from '@angular/core';
import {UserService} from '../../services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PreviewModalService} from '../../shared/services/preview-modal.service';
import {AccountService} from '../../services/account.service';
import {AlertService} from '../../shared/services/alert.service';
import {AbstractControl, FormControl, FormGroup, Validator, Validators} from '@angular/forms';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  public requestingReset: boolean;
  public resettingPassword: boolean;
  public passwordMismatch: boolean;
  public confirmPasswordIsEmpty: boolean;
  public passwordIsEmpty: boolean;
  public userLogin = {'password': '', 'confirmPassword': ''};
  id: number;
  token: string;
  public loginUrl = environment.stsAuthority;
  constructor(private router: Router, private route: ActivatedRoute, private accountService: AccountService, private alertService: AlertService) { }

  ngOnInit() {
    const id = this.route.snapshot.params['id'];
    const token = this.route.snapshot.params['token'];
    if (id && token) {
      this.id = id;
      this.token = token;
      this.validateResetToken(id, token);
      this.requestingReset = false;
    }else {
      this.requestingReset = true;
      this.resettingPassword = false;
    }


  }

  validateResetToken(id, token) {
    this.accountService.validateResetToken(id, token).subscribe(
      res => {
        if (res) {
          this.resettingPassword = true;
          this.requestingReset = false;
        }else {
          this.alertService.error('Reset link used has expired.');
          this.requestingReset = true;
        }

      },
      err => {
        this.alertService.error('Reset link used has expired.');
      }
    );
  }

  resetPassword(username) {
    console.log(username.value);
    this.accountService.sendResetPasswordLink(username.value).subscribe(
      res => {
        if(res){
          this.alertService.success('Password reset successful. An email has been sent with a reset link.');
        } else {
          this.alertService.error('Resetting password failed, the username you entered doesn\'t exist.');  
        }
        
      }, err => {
        this.alertService.error('Resetting password failed, please try again later.');
      }
    );
  }
  
  submitNewPassword(password, confirmPassword) {
    this.confirmPasswordIsEmpty = false;
    this.passwordIsEmpty = false;
    this.passwordMismatch = false;
    if (!password.value && !confirmPassword.value) {
      this.passwordIsEmpty = true;
      this.confirmPasswordIsEmpty = true;
    } else if (!password.value) {
      this.passwordIsEmpty = true;
    } else if (!confirmPassword.value) {
      this.confirmPasswordIsEmpty = true;
    }
    else if (password.value === confirmPassword.value) {
      this.confirmPasswordIsEmpty = false;
      this.passwordIsEmpty = false;

      const resetPasswordData = {'id': this.id, 'token': this.token, 'password': password.value};
        this.accountService.resetPassword(resetPasswordData).subscribe(
          res => {
            this.alertService.success('Password has been successfully changed.');
            }, err => {
            this.alertService.error('Changing password failed, please try again later');
          }
        );
    }else {
      // password mismatch
      this.confirmPasswordIsEmpty = false;
      this.passwordIsEmpty = false;
      this.passwordMismatch = true;
    }
  }



}
